import styled from "styled-components";
import { BootstrapGrid } from "../../components/layouts/BootstrapGrid";
import Card from "../../components/layouts/Card";
import PageWrapper from "../../components/layouts/PageWrapper"

const BuildingManagement = () => {
  return (
    <PageWrapper>
      <BuildingManagementWrapper>
        <BootstrapGrid>
          <div className="row">
            <div className="col-md-4">
              <Card>
                <div className="card--title">
                  <h2 className="card--title-title">Manajemen Gedung</h2>
                </div>
                <div className="card--body">
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis at suscipit nisi. Donec pellentesque lacus vitae vestibulum gravida. Mauris libero nunc, gravida quis est a, rhoncus elementum lectus. Quisque laoreet augue id ipsum eleifend interdum. Vestibulum metus ante, varius ut dapibus eget, lacinia vitae sem. Praesent et rhoncus massa. Aenean mattis, felis vel commodo hendrerit, erat dolor aliquet libero, non convallis diam dui id enim.</p>
                  <br/>
                  <p>In in enim ante. Etiam malesuada euismod tellus, eu semper massa cursus quis. Sed gravida tincidunt dolor quis vulputate. Curabitur condimentum, velit ut venenatis porta, ligula velit fringilla dolor, a placerat nibh neque at purus. Maecenas ut pharetra dui, non sollicitudin dolor. Curabitur id lacus diam. Vestibulum vel viverra metus. Vivamus tempor semper lectus, a dapibus nulla suscipit at. Ut vel consequat massa.</p>
                  <br/>
                  <p>Sed sit amet magna ullamcorper, auctor urna in, bibendum lorem. Cras eget bibendum velit. Ut non lorem eu ipsum mollis molestie. Maecenas sed quam arcu. Proin viverra iaculis nibh eget volutpat. Suspendisse non finibus purus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Aenean euismod elit eu mi iaculis, sit amet aliquet leo scelerisque. Sed fermentum dignissim rutrum. Donec rutrum, libero nec facilisis dapibus, erat est cursus elit, vel viverra diam nulla at sem. Fusce quis metus sed felis laoreet semper ut semper sapien. Cras tortor est, pretium quis dictum a, consectetur vitae odio. Aliquam nec odio lorem.</p>
                </div>
              </Card>
            </div>
          </div>
        </BootstrapGrid>
      </BuildingManagementWrapper>
    </PageWrapper>
  )
}

const BuildingManagementWrapper = styled.div``;

export default BuildingManagement;